import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import Sidebar from './Sidebar';
import DefaultEdit from './DefaultEdit';

const Edit = ({
  block,
  openObjectBrowser,
  onChangeBlock,
  selected,
  data,
  ...rest
}) => {
  const [slideIndex, setSlideIndex] = useState(0);

  const handleSetSlideIndex = useCallback((index) => {
    setSlideIndex(index);
  }, []);

  return (
    <>
      <DefaultEdit
        {...rest}
        block={block}
        data={data}
        openObjectBrowser={openObjectBrowser}
        onChangeBlock={onChangeBlock}
        slideIndex={slideIndex}
        setSlideIndex={handleSetSlideIndex}
      />

      <SidebarPortal selected={selected}>
        <Sidebar
          {...rest}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
          activeObject={slideIndex}
          setActiveObject={handleSetSlideIndex}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string.isRequired,
  openObjectBrowser: PropTypes.func.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
};

export default withBlockExtensions(Edit);
